import { useEffect, useState } from 'react';

/**
 * Tick a 1-second countdown to the given target date and produce a formatted
 * `XXД XXЧ XXМ XXС` string. We use 1s polling rather than rAF on purpose:
 * the timer is purely informational and a bigger interval keeps the
 * component cheap inside a Telegram WebView.
 */
export function useCountdown(target: Date) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(id);
    }, []);

    const diff = target.getTime() - now;
    if (diff <= 0) return 'ЗАВЕРШЕНО';

    const pad = (n: number) => String(n).padStart(2, '0');
    const days = Math.floor(diff / 86_400_000);
    const hours = Math.floor((diff % 86_400_000) / 3_600_000);
    const mins = Math.floor((diff % 3_600_000) / 60_000);
    const secs = Math.floor((diff % 60_000) / 1000);
    return `${pad(days)}Д ${pad(hours)}Ч ${pad(mins)}М ${pad(secs)}С`;
}
